import { Chip, Theme } from '@mui/material'
import { MUIStyledCommonProps, styled } from '@mui/system'

interface IPriceTagProps extends MUIStyledCommonProps<Theme> {
  height: number | string
}

export const PriceTag = styled(Chip)<IPriceTagProps>`
  position: relative;
  border-radius: 0 4px 4px 0;
  height: calc(${(props) => props.height} * 2);
  font-weight: 500;

  :after {
    content: '';
    background-color: white;
    border-radius: 50%;
    width: 4px;
    height: 4px;
    display: block;
    position: absolute;
    left: calc(${(props) => props.height} / -2);
    top: calc(${(props) => props.height} - 2px);
  }

  :before {
    content: '';
    position: absolute;
    display: block;
    left: ${(props) => `-${props.height}`};
    width: 0;
    height: 0;
    border-top: ${(props) => props.height} solid transparent;
    border-bottom: ${(props) => props.height} solid transparent;
    border-right: ${(props) => props.height} solid ${(props) => props.theme.palette.primary.main};
  }
`
